import { Model } from 'vuex-orm';

import App from '../app/model';

export default class Role extends Model {
  static entity = 'roles';

  static fields() {
    return {
      id: this.attr(null),
      app_id: this.attr(null),
      name: this.attr(''),
      machine_name: this.attr(''),

      app: this.belongsTo(App, 'app_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/role/model.js